export default "/wp-content/themes/onnit/script/cart/dist/stiUpsellBg-c730fe1e.jpg";